import { render, staticRenderFns } from "./rewardFloor.vue?vue&type=template&id=1a8c39ae&scoped=true&"
import script from "./rewardFloor.vue?vue&type=script&lang=js&"
export * from "./rewardFloor.vue?vue&type=script&lang=js&"
import style0 from "./rewardFloor.vue?vue&type=style&index=0&id=1a8c39ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8c39ae",
  null
  
)

export default component.exports